import { trackEvent, ACTIONS } from 'common/analytics';
import { track } from 'src/tracking/trackingService';

export class ClientAppAnalytics {
  static CATEGORY = 'tw-client-app';

  static trackFacebook() {
    track('marketing.management.client_app.facebook_share.clicked');
  }

  static trackTwitter() {
    track('marketing.management.client_app.twitter_share.clicked');
  }

  static trackClipboard() {
    trackEvent(ClientAppAnalytics.CATEGORY, ACTIONS.CLICK, 'copy-link');
  }

  static trackGooglePlay() {
    trackEvent(ClientAppAnalytics.CATEGORY, ACTIONS.CLICK, 'google-play');
  }

  static trackAppStore() {
    trackEvent(ClientAppAnalytics.CATEGORY, ACTIONS.CLICK, 'app-store');
  }

  static trackHelpCenter() {
    trackEvent(ClientAppAnalytics.CATEGORY, ACTIONS.CLICK, 'help-center');
  }
}
